import { Box, Button, ConnectQuickBooksButton, Grid, Text } from '@approvalmax/ui/src/components';
import { FC } from 'react';

import { CardLogo } from '../CardLogo/CardLogo';
import { ConnectCardProps } from './ConnectCard.types';

export const ConnectCard: FC<ConnectCardProps> = (props) => {
    const { title, logo, header, description, buttonText, onClick, isLoading, withConnectQuickBooksButton } = props;

    return (
        <Box bordered borderColor='midnight50' radius='small' spacing='16'>
            <Grid gap={24} justifyItems='center' height='100%' alignContent='space-between'>
                <Grid gap={12}>
                    <CardLogo logo={logo} title={title} />

                    <Text font='body' fontSize='small' fontWeight='medium'>
                        {header}
                    </Text>

                    <Text font='body' fontSize='small'>
                        {description}
                    </Text>
                </Grid>

                {withConnectQuickBooksButton ? (
                    <ConnectQuickBooksButton size='small' onClick={onClick} disabled={isLoading} />
                ) : (
                    <Button color='blue80' size='small' onClick={onClick} disabled={isLoading}>
                        {buttonText}
                    </Button>
                )}
            </Grid>
        </Box>
    );
};
